import type { ColumnSchema } from './columnSchema.js';

export const VAR_COLUMNS: ColumnSchema[] = [
  {
    field: 'var_id',
    dbCol: 'var_id',
    title: 'VAR ID',
    filterable: true,
    order: 1,
    mobile: { order: 1, width: 70 },
  },
  {
    field: 'name',
    dbCol: 'name',
    title: 'Title',
    filterable: true,
    order: 2,
    mobile: { order: 2, width: 120 },
  },
  {
    field: 'details',
    dbCol: 'details',
    title: 'Details',
    filterable: true,
    order: 3,
    mobile: { hidden: true },
  },
  {
    field: 'region',
    dbCol: 'region',
    title: 'Region',
    filterable: true,
    order: 4,
    mobile: { hidden: true },
  },
  { field: 'regionName', dbCol: 'region_name', title: 'Region Name', excludeFromGrid: true },
  {
    field: 'var_type',
    dbCol: 'var_type',
    title: 'Category',
    filterable: true,
    order: 5,
    mobile: { order: 3, width: 80 },
  },
  {
    field: 'var_subtype',
    dbCol: 'var_subtype',
    title: 'Subcategory',
    filterable: true,
    order: 6,
    mobile: { hidden: true },
  },
  {
    field: 'keywords',
    dbCol: '',
    title: 'Keywords',
    filterable: true,
    sortable: false,
    order: 7,
    mobile: { hidden: true },
    excludeFromExport: true,
  },
  {
    field: 'occupancy',
    dbCol: 'occupancy',
    title: 'Occupancy',
    filterable: true,
    order: 8,
    mobile: { hidden: true },
  },
  {
    field: 'status',
    dbCol: 'status',
    title: 'Status',
    filterable: true,
    order: 9,
    mobile: { hidden: true },
  },
  {
    field: 'red_flag_active',
    dbCol: 'red_flag_active',
    title: 'Red Flag',
    filterable: true,
    order: 10,
    mobile: { hidden: true },
  },
  {
    field: 'sprinklerFlag',
    dbCol: `(sprinkler_flag->>'active')`,
    title: 'Sprinkler',
    filterable: true,
    order: 11,
    mobile: { hidden: true },
  },
  {
    field: 'photos',
    dbCol: `jsonb_array_length(COALESCE(photos, '[]'::jsonb))`,
    title: 'Photos',
    filterable: false,
    order: 12,
    mobile: { hidden: true },
  },
  {
    field: 'verification',
    dbCol: '',
    sortExpr: `verification->>'Date'`,
    title: 'Verified',
    filterable: true,
    order: 13,
    mobile: { hidden: true },
    excludeFromExport: true,
  },
  { field: 'lat', dbCol: 'ST_Y(location)', title: 'Latitude', excludeFromGrid: true },
  { field: 'lon', dbCol: 'ST_X(location)', title: 'Longitude', excludeFromGrid: true },
];
